import api from "./../api";
import UtilsUrl from "./../../utils/UtilsUrl";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";

class CampagneEmailService {
  //Afficher List CampagneEmails
  AfficherListCampagneEmail(idUser) {
    return api.get(UtilsUrl.marketingURL() + "/campagneEmail/getAll/" + idUser);
  }

  //Afficher List Objectifs
  AfficherListObjectifs() {
    return api.get(UtilsUrl.marketingURL() + "/getObjectifs");
  }

  //Afficher List Types
  AfficherListTypes() {
    return api.get(UtilsUrl.marketingURL() + "/getTypes");
  }

  //Afficher List CanalDiffusion
  AfficherListCanalDiffusion() {
    return api.get(UtilsUrl.marketingURL() + "/getCanalDiffusions");
  }

  //Afficher List Statut
  AfficherListStatus() {
    return api.get(UtilsUrl.marketingURL() + "/campagneEmail/getStatus");
  }

  // Obtenir la liste des ID de photos dans une CampagneEmail
  getCampagneEmailPhotosId(id) {
    return api.get(UtilsUrl.marketingURL() + "/ListImages/" + id);
  }

  // Afficher une image par son ID
  showImage(imageId) {
    return api
      .get(UtilsUrl.marketingURL() + "/showImage/" + imageId, {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const arrayBufferView = new Uint8Array(response.data);
        const blob = new Blob([arrayBufferView], {
          type: response.headers["content-type"],
        });
        const imageUrl = URL.createObjectURL(blob);
        return imageUrl;
      });
  }

  ajouterCampagneEmail(nouvelleCampagneEmail, clientIds, file, images) {
    const formData = new FormData();
    formData.append("idUser", getCurrentUserId());

    formData.append("campagneEmail", JSON.stringify(nouvelleCampagneEmail));
    formData.append("clientIds", clientIds);
    formData.append("file", file);
    for (let i = 0; i < images.length; i++) {
      formData.append("images", images[i]);
    }
    return api.post(UtilsUrl.marketingURL() + "/campagneEmail/Add", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  //mettreAJour CampagneEmail
  mettreAJourCampagneEmail(
    updatedCampagneEmail,
    clientIds,
    CampagneEmailId,
    images
  ) {
    const formData = new FormData();
    formData.append("clientIds", clientIds);
    formData.append("campagneEmail", JSON.stringify(updatedCampagneEmail));
    for (let i = 0; i < images.length; i++) {
      formData.append("images", images[i]);
    }
    return api.put(UtilsUrl.marketingURL() + "/update/" + CampagneEmailId, formData, {
      headers: {
        "Content-Type": "multipart/form-data", // Set the content type to multipart/form-data
      },
    });
  }

  //supprimer CampagneEmail
  supprimerCampagneEmail(CampagneEmailId) {
    return api.put(UtilsUrl.marketingURL() + "/delete/" + CampagneEmailId, {
      headers: {
        "Content-Type": "multipart/form-data", // Set the content type to multipart/form-data
      },
    });
  }

  //get CampagneEmail By ID
  getCampagneEmailByID(CampagneEmailId) {
    return api.get(UtilsUrl.marketingURL() + "/get/" + CampagneEmailId);
  }

  //filtre
  getCampagneEmailByFiltre(nom, statut, debutDate, finDate) {
    return api.get(
      UtilsUrl.marketingURL() +
      "/filtre?nom=" +
      nom +
      "&statut=" +
      statut +
      "&debutDate=" +
      debutDate +
      "&finDate=" +
      finDate
    );
  }

  //CSV Methodes
  ImporterCSV(file) {
    return api.post(UtilsUrl.marketingURL() + "/importcsv", file);
  }

  Exportcsv(nom, canalDiffusion, type, debutDate, finDate) {
    return api.get(
      UtilsUrl.marketingURL() +
      "/exportcsv?nom=" +
      nom +
      "&type=" +
      type +
      "&canalDiffusion=" +
      canalDiffusion +
      "&debutDate=" +
      debutDate +
      "&finDate=" +
      finDate,
      {
        responseType: "blob",
      }
    );
  }
  //Stat clients  By email
  //get number clients By email
  getClientCountByCampagneEmailId(CampagneEmailId) {
    return api.get(
      UtilsUrl.marketingURL() + "/get/" + CampagneEmailId + "/clientCount"
    );
  }
  //get count of genre clients By email
  countgenres(CampagneEmailId) {
    return api.get(
      UtilsUrl.marketingURL() + "/get/" + CampagneEmailId + "/clientCountGenre",
      {
        headers: {
          "Content-Type": "multipart/form-data", // Set the content type to multipart/form-data
        },
      }
    );
  }
}

export default new CampagneEmailService();
